import { render, staticRenderFns } from "./PortalSwitch.vue?vue&type=template&id=dfb9b6c6&scoped=true"
import script from "./PortalSwitch.vue?vue&type=script&lang=js"
export * from "./PortalSwitch.vue?vue&type=script&lang=js"
import style0 from "./PortalSwitch.vue?vue&type=style&index=0&id=dfb9b6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb9b6c6",
  null
  
)

export default component.exports